export default __webpack_public_path__ + "static/media/footer_ad_tea.f7c0e92e.png";